import { useQuery } from 'react-query'
import companyQueryStrings from '../../../../constants/companyQueryStrings'
import { apiGetData } from '../../../../../../core/utils/api/generic'
import AddressType from '../../../../../../types/shared/AddressType'

const useGetCompanyAddresses = () =>
  useQuery([companyQueryStrings.company_addresses], () => apiGetData<AddressType[]>('/addresses/company'))

export default useGetCompanyAddresses
